import React from 'react';
import { chevronLeftIcon, PathElement } from '@chordbaker/design';

const [chevron] = chevronLeftIcon.elements as [PathElement];

interface ChevronLeftIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

/** A left-pointing chevron; rotate it for other directions. */
const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({ size = chevronLeftIcon.defaultSize, color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={chevronLeftIcon.viewBox}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d={chevron.d}
      stroke={color}
      strokeWidth={chevron.strokeWidth}
      strokeLinecap={chevron.strokeLinecap as React.SVGAttributes<SVGPathElement>['strokeLinecap']}
      strokeLinejoin={chevron.strokeLinejoin as React.SVGAttributes<SVGPathElement>['strokeLinejoin']}
    />
  </svg>
);

export default ChevronLeftIcon;
